import josua from '../../../../assets/members/josua.png';
import tegar from '../../../../assets/members/tegar.png';
import tio from '../../../../assets/members/tio.png';

export const content = [
  {
    img: josua,
    name: 'Josuanstya Lovdianchel',
    role: '- Hacker -',
    quotes: '“Jarak antara kamu dan mimpimu itu cuma satu, action.”',
    social: {
      wa: 'https://wa.me/6289528710280',
      ig: 'https://instagram.com/lovdianchel',
      li: 'https://linkedin.com/in/lovdianchel/',
    },
  },
  {
    img: tegar,
    name: 'Tegar Bayu Laksmana',
    role: '- Hustler -',
    quotes:
      '“Semakin kita tahu banyak hal, seharusnya semakin kita sadar kita gak tahu apa-apa.”',
    social: {
      wa: 'https://wa.me/6282228677931',
      ig: 'https://instagram.com/tblaksmana',
      li: 'https://www.linkedin.com/in/tegar-bayu-laksmana-09362a175/',
    },
  },
  {
    img: tio,
    name: 'Hanafi Satriyo Utomo S.',
    role: '- Hipster -',
    quotes:
      '“Sang juara percaya kepada dirinya sendiri bahkan ketika orang lain tidak percaya.”',
    social: {
      wa: 'https://wa.me/6281353033922',
      ig: 'https://instagram.com/tio.stwn_',
      li: 'https://linkedin.com/in/tiostwn/',
    },
  },
];
